"use strict";import{tag as c}from"../custom-tag.js";export{setCustomTemplateLiteralTag}from"../custom-tag.js";export const CCLibraryIcon=({width:r=24,height:t=24,hidden:e=!1,title:l="CCLibrary"}={})=>c`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${r}"
    height="${t}"
    viewBox="0 0 20 20"
    aria-hidden=${e?"true":"false"}
    role="img"
    fill="currentColor"
    aria-label="${l}"
  >
    <path
      d="m2.75,15c-.41406,0-.75-.33594-.75-.75V4.25c0-1.24023,1.00928-2.25,2.25-2.25h10c.41406,0,.75.33594.75.75s-.33594.75-.75.75H4.25c-.41357,0-.75.33691-.75.75v10c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m15.62988,5H7.37012c-1.30713,0-2.37012,1.06348-2.37012,2.37012v8.25977c0,1.30664,1.06299,2.37012,2.37012,2.37012h8.25977c1.30713,0,2.37012-1.06348,2.37012-2.37012V7.37012c0-1.30664-1.06299-2.37012-2.37012-2.37012Zm.87012,10.62988c0,.47949-.39014.87012-.87012.87012H7.37012c-.47998,0-.87012-.39062-.87012-.87012V7.37012c0-.47949.39014-.87012.87012-.87012h3.62988v4.13428c0,.35645.43085.53491.68286.28271l1.0343-1.03418c.15619-.15625.40948-.15625.56567,0l1.0343,1.03418c.25201.2522.68286.07373.68286-.28271v-4.13428h.62988c.47998,0,.87012.39062.87012.87012v8.25977Z"
      fill="currentColor"
    />
  </svg>`;
//# sourceMappingURL=CCLibrary.js.map
